import React, { Component } from 'react';
import Landing from './Components/Home/Landing/Landing';
import Terms from './Components/Home/Terms/TermsConditions';
import Privacy from './Components/Home/Privacy/Privacy';
import About from './Components/Home/About/About';
import Contact from './Components/Home/Contact/Contact';
import Premium from './Components/Home/Premium/Premium';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Signin from './Components/Signin/Signin';
import AdminSignin from './Components/Signin/AdminSignin';
import Register from './Components/Register/Register';
import Dashboard from './Components/Dashboard/Dashboard';
import Create from './Components/Create/Create';
import ScrollToTop from './ScrollToTop'

class App extends Component {
  constructor(props) {
      super()
      this.state = {
         visible:true
      }
   }
  render() {
    return (
      <div className='body-container fadeIn'>
      <Router>
      <ScrollToTop>
       <Switch>
                  <Route exact path='/' component={Landing} />
                  <Route exact path='/about' component={About} />
                  <Route exact path='/contact' component={Contact} />
                  <Route exact path='/premium' component={Premium} />
                  <Route exact path='/terms' component={Terms} />
                  <Route exact path='/privacy-policy' component={Privacy} />
                  <Route exact path='/signin' component={Signin} />
                  <Route exact path='/v-admin' component={AdminSignin} />
                  <Route exact path='/register' component={Register} />
                  <Route exact path='/create' component={Create} />
                  <Route exact path='/dashboard' component={Dashboard} />
       </Switch>
       </ScrollToTop>
       </Router>
       </div>
    );
  }
}

export default App;
